import { createContext, useContext, useReducer } from "react";

const formReducer = (state, action) => {
  switch (action.type) {
    case "set_tipologia":
      return {
        ...state,
        tipologia: action.payload,
      };
    case "set_datiAzienda":
      return {
        ...state,
        datiAzienda: { ...state.datiAzienda, ...action.payload },
      };
    case "set_datiResponsabile":
      return {
        ...state,
        datiResponsabile: { ...state.datiResponsabile, ...action.payload },
      };
    case "set_ivassRUI": {
      const { section, data } = action.payload;
      return {
        ...state,
        [section]: {
          ...state[section],
          ivassRUI: {
            ...(state[section]?.ivassRUI || {}),
            ...data,
          },
        },
      };
    }
    case "set_credenziali":
      return {
        ...state,
        credenziali: { ...state.credenziali, ...action.payload },
      };
    case "reset_and_set_section": {
      return {
        ...state,
        datiAzienda: { ...initialData.datiAzienda },
        datiResponsabile: { ...initialData.datiResponsabile },
      };
    }
    default:
      return state;
  }
};

const FormContext = createContext(null);

const initialData = {
  tipologia: "societa",
  datiAzienda: {
    tipologiaAzienda: 0,
    ragioneSociale: "",
    pIva: "",
    provincia: "",
    comune: "",
    cap: "",
    viacorso: "",
    indirizzo: "",
    civico: "",
    telefono: "",
    fax: "",
    email: "",
    pec: "",
    ivassRUI: {
      sezioneRUI: "",
      codiceRUI: "",
      dataIscrizioneRUI: "",
    },
  },
  datiResponsabile: {
    cognome: "",
    nome: "",
    cf: "",
    provincia: "",
    comune: "",
    cap: "",
    viacorso: "",
    indirizzo: "",
    civico: "",
    cellulare: "",
    ivassRUI: {
      sezioneRUI: "",
      codiceRUI: "",
      dataIscrizioneRUI: "",
    },
  },
  credenziali: {
    email: "",
    password: "",
    confermaPassword: "",
  },
};

/* const initialData = {
  tipologia: "societa",
  datiAzienda: {
    tipologiaAzienda: 0,
    ragioneSociale: "test",
    pIva: "12345678901",
    provincia: "AG",
    comune: "",
    cap: "",
    viacorso: "CONTRADA",
    indirizzo: "test",
    civico: "1",
    telefono: "",
    fax: "",
    email: "test@g.com",
    pec: "",
    ivassRUI: {
      sezioneRUI: 2,
      codiceRUI: "123456789",
      dataIscrizioneRUI: "22/06/2024",
    },
  },
  datiResponsabile: {
    cognome: "Test",
    nome: "Test",
    cf: "RTRVLN01S24Z129Q",
    provincia: "AG",
    comune: "",
    cap: "",
    viacorso: "CONTRADA",
    indirizzo: "test",
    civico: "1",
    cellulare: "123456789",
    ivassRUI: {
      sezioneRUI: 2,
      codiceRUI: "123456789",
      dataIscrizioneRUI: "22/06/2024",
    },
  },
  credenziali: {
    email: "reyrotaru1@gmail.com",
    password: "Testtest1!",
    confermaPassword: "Testtest1!",
  },
}; */

export const FormIscrizioneProvider = ({ children }) => {
  const [formState, dispatch] = useReducer(formReducer, initialData);

  return (
    <FormContext.Provider value={{ formState, dispatch }}>
      {children}
    </FormContext.Provider>
  );
};

// Hook to use form context
export const useFormIscrizione = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
};

export const sezioneCodiciRUI = [
  { value: 1, label: "A" },
  { value: 2, label: "B" },
  { value: 3, label: "E" },
  { value: 4, label: "E accessorio" },
];
